









// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { AloGroupCarac, getDefaultAloGroupCarac } from '@/models/alo/AloGroupCarac';

@Component({
  name: 'EditBaseGroupCarac',    
  components:{EditDrawer},
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBaseGroupCarac extends Vue {
  
  private original = getDefaultAloGroupCarac()
  private modified = getDefaultAloGroupCarac()
  private showDrawer = false
  private saving = false 

  edit(item:AloGroupCarac) {        
    this.$store.myActions.ADM_GROUP_CARAC_RESET_STATUS()
    this.showDrawer = true
    this.original = item
    this.modified = cloneDeep(item) 

    return this.modified   
  }  

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get groupCaracStatus() {
    return this.$store.myGetters.groupCaracStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_GROUP_CARAC_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.groupCaracStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

  
}
